<div *ngIf="value$ | async" class="item">
  <div class="row">
    <div class="category">
      {{ categoryName$ | async }}
    </div>
    <div class="provider">
      {{ providerName$ | async }}
    </div>
    <div class="reference">
      {{ (value$ | async)?.providerReference }}
    </div>
  </div>
  <div class="subscriber row">
    <span>Preneur: {{ subscriberLabel$| async}}</span>
  </div>
  <div class="date row" *ngIf="(value$ | async)?.nextAnniversaryDate">
    <span>Prochaine échéance: {{ (value$ | async)?.nextAnniversaryDate | date:'shortDate'}}</span>
  </div>
</div>
